import ReactPixel from 'react-facebook-pixel';



export const hemenBaslaEvent = ()=> 
{   
  ReactPixel.trackCustom('HemenBasla', 'HemenBasla');
  // fbq('trackCustom', 'HemenBasla');
}

export const uyeGirisiKayitOlEvent = ()=> 
{   
  ReactPixel.trackCustom('UyeGirisiKayitOl', 'UyeGirisiKayitOl');
  // fbq('trackCustom', 'UyeGirisiKayitOl');
}

export const uyeOlButtonClickEvent = ()=> 
{   
  ReactPixel.trackCustom('UyeOlButtonClick', 'UyeOlButtonClick');
  // fbq('trackCustom', 'UyeOlButtonClick');
}